import React from "react";
import Layout from "./Layout";
import { Link, useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";

const Refer = () => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const navigate = useNavigate();
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Refer a friend now and earn commission",
          text: "Join using my referral link",
          url: `https://${window.location.hostname.replace(/^(www|ag|msa|bxawscf|velki|aff)\./, "")}/register?referral_code=${profileData?.referalCode}`,
        });
        console.log("Shared successfully");
      } catch (error) {
        console.log("Error sharing:", error);
      }
    } else {
      alert("Sharing not supported on this browser");
    }
  };
  return (
    <Layout>
      <div className="justify-space-around referralLayout hidden-md-and-up v-card v-sheet theme--light elevation-0">
        <div className="v-image v-responsive theme--light">
          <div
            className="v-responsive__sizer"
            style={{ "padding-bottom": "23.0769%" }}
          />
          <div
            className="v-image__image v-image__image--cover"
            style={{
              "background-image": 'url("/assets/new/referral_banner_en.jpg")',
              "background-position": "center center",
            }}
          />
          <div className="v-responsive__content">
            <div className="row no-gutters justify-end" />
          </div>
        </div>
        <div
          style={{
            background: "black",
            backgroundColor: "black",
            height: "50px",
          }}
          className="row mobile-header no-gutters"
        >
          <div className="text-center mobile-header-item ma-0 col col-6 selected">
            <Link
              to="/refer"
              className="router-link-exact-active router-link-active"
              style={{
                "-webkit-text-decoration": "unset !important",
                "text-decoration": "unset !important",
              }}
            >
              <span>My Referrals</span>
            </Link>
          </div>
          <div className="text-center mobile-header-item ma-0 col col-6">
            <Link
              to="/refer"
              className
              style={{
                "-webkit-text-decoration": "unset !important",
                "text-decoration": "unset !important",
              }}
            >
              <span>My Commission</span>
            </Link>
          </div>
        </div>
        <div className="v-card__text referralContainer">
          <div className="referral-tier">
            <div className="row hidden-sm-and-down no-gutters">
              <div className="col-sm-3 col-lg-2 col-2">
                <label style={{ color: "rgb(255, 255, 255)" }}>
                  Total Tier 1 Member:
                </label>
                <div
                  className="primary orangeText title text-center pa-1 mt-3 v-card v-sheet theme--light"
                  style={{ "background-color": "rgb(254, 19, 160) !important" }}
                >
                  <i
                    aria-hidden="true"
                    className="v-icon notranslate orangeText material-icons theme--light"
                  >
                    person
                  </i>
                  : 0
                </div>
                <div className="detail-card base mt-3 pt-2 px-1 v-card v-sheet theme--light">
                  <div className="v-card__title title">Tier 1</div>
                  <hr
                    role="separator"
                    aria-orientation="horizontal"
                    className="mx-3 primary v-divider theme--light"
                  />
                  <div className="v-card__text">
                    <div className="row">
                      <div className="col col-12">
                        <label className="detail">2.5% of downlines</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col col-1" />
              <div className="col-sm-3 col-lg-2 col-2">
                <label style={{ color: "rgb(255, 255, 255)" }}>
                  Total Tier 2 Member:
                </label>
                <div
                  className="primary orangeText title text-center pa-1 mt-3 v-card v-sheet theme--light"
                  style={{ "background-color": "rgb(254, 19, 160) !important" }}
                >
                  <i
                    aria-hidden="true"
                    className="v-icon notranslate orangeText material-icons theme--light"
                  >
                    person
                  </i>
                  : 0
                </div>
                <div className="detail-card base mt-3 pt-2 px-1 v-card v-sheet theme--light">
                  <div className="v-card__title title">Tier 2</div>
                  <hr
                    role="separator"
                    aria-orientation="horizontal"
                    className="mx-3 primary v-divider theme--light"
                  />
                  <div className="v-card__text">
                    <div className="row">
                      <div className="col col-12">
                        <label className="detail">1.5% of downlines</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col col-1" />
              <div className="col-sm-3 col-lg-2 col-2">
                <label style={{ color: "rgb(255, 255, 255)" }}>
                  Total Tier 3 Member:
                </label>
                <div
                  className="primary orangeText title text-center pa-1 mt-3 v-card v-sheet theme--light"
                  style={{ "background-color": "rgb(254, 19, 160) !important" }}
                >
                  <i
                    aria-hidden="true"
                    className="v-icon notranslate orangeText material-icons theme--light"
                  >
                    person
                  </i>
                  : 0
                </div>
                <div className="detail-card base mt-3 pt-2 px-1 v-card v-sheet theme--light">
                  <div className="v-card__title title">Tier 3</div>
                  <hr
                    role="separator"
                    aria-orientation="horizontal"
                    className="mx-3 primary v-divider theme--light"
                  />
                  <div className="v-card__text">
                    <div className="row">
                      <div className="col col-12">
                        <label className="detail">1% of downlines</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row hidden-md-and-up no-gutters">
              <div className="col col-12">
                <p style={{ color: "black" }}>
                  Share your referral code with your friend now and start
                  earning extra cash for every friend you invite.
                  <span style={{ color: "black" }}>
                    Get lifetime commission up to a total of 5% commission every
                    time your friend makes a deposit!
                  </span>
                </p>
                {isEmpty(user) ? (
                  <div className="row">
                    <div className="col col-12">
                      <span style={{ color: "black" }}>
                        Login / Register to get your referral code:
                      </span>
                    </div>
                    <div
                      onClick={() => navigate("/register")}
                      className="inpage-before-login-first text-center beforeLoginBtn col"
                    >
                      <b>Sign Up</b>
                    </div>
                    <div
                      onClick={() => navigate("/login")}
                      className="inpage-navigator-before-login-second text-center beforeLoginBtn col"
                    >
                      <b>Login</b>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="text-left pb-0 col col-12">
                      <span style={{ color: "black" }}>
                        Your Referral Code :
                      </span>
                    </div>
                    <div className="col col-12">
                      <div
                        className="row no-gutters"
                        style={{ height: "auto" }}
                      >
                        <div className="pa-0 col-sm-8 col-md-6 col-8">
                          <div className="referralCode-card text-center v-card v-sheet theme--light">
                            <div
                              className="v-card__text pa-3"
                              style={{ color: "rgb(255, 255, 255) !important" }}
                            >
                              {profileData?.referalCode}
                            </div>
                            <span />
                          </div>
                        </div>
                        <div
                          onClick={handleShare}
                          className="pa-0 pl-2 col col-4"
                        >
                          <div
                            tabIndex={0}
                            className="fill-height share-card pa-3 v-card v-card--link v-sheet theme--light"
                          >
                            <span
                              style={{
                                "font-size": "0.8rem",
                                color: "rgb(255, 255, 255)",
                              }}
                            >
                              SHARE
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row hidden-md-and-up no-gutters">
              <div col={12} className="timeline-container col">
                <div
                  className="v-timeline v-timeline--dense theme--light"
                  style={{ "margin-left": "-12px" }}
                >
                  {!isEmpty(user) && (
                    <div className="v-timeline-item active-tier v-timeline-item--fill-dot theme--light">
                      <div className="v-timeline-item__body">
                        <div
                          className="row"
                          style={{
                            "-webkit-align-items": "center",
                            "-webkit-box-align": "center",
                            "-ms-flex-align": "center",
                            "align-items": "center",
                            "margin-right": "0px !important",
                          }}
                        >
                          <div className="col col-8">
                            <div className="tier-card text-center active-tier v-card v-sheet theme--light">
                              <div className="v-card__text pa-2">
                                {user?.user?.username}
                              </div>
                            </div>
                          </div>
                          <div className="col" style={{ padding: "unset" }}>
                            <div className="tier-card text-center active-tier v-card v-sheet theme--light">
                              <div className="v-card__text pa-2">0</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="v-timeline-item__divider">
                        <div className="v-timeline-item__dot">
                          <div
                            className="v-timeline-item__inner-dot"
                            style={{
                              "background-color":
                                "rgb(145, 44, 246) !important",
                              "border-color": "rgb(145, 44, 246) !important",
                            }}
                          >
                            <img
                              src="/assets/icon/tier-icon-white.svg"
                              style={{ width: "22px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                    <div className="v-timeline-item__body">
                      <div
                        className="row"
                        style={{
                          "-webkit-align-items": "center",
                          "-webkit-box-align": "center",
                          "-ms-flex-align": "center",
                          "align-items": "center",
                          "margin-right": "0px !important",
                        }}
                      >
                        <div className="col col-8">
                          <div
                            className="tier-card text-center v-card v-sheet theme--light"
                            style={{
                              "background-color": "rgb(255, 255, 255)",
                              "border-color": "rgb(255, 255, 255)",
                            }}
                          >
                            <div className="v-card__text font-weight-bold pa-2">
                              Tier 1 (2.5%)
                            </div>
                          </div>
                        </div>
                        <div className="col" style={{ padding: "unset" }}>
                          <div className="v-card v-sheet theme--light">
                            <div className="v-card__text tier-card text-center pa-2">
                              0
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-timeline-item__divider">
                      <div className="v-timeline-item__dot">
                        <div
                          className="v-timeline-item__inner-dot"
                          style={{
                            "background-color": "rgb(255, 255, 255)",
                            "border-color": "rgb(255, 255, 255)",
                          }}
                        >
                          <img
                            src="/assets/icon/tier-icon-black.svg"
                            style={{ width: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                    <div className="v-timeline-item__body">
                      <div
                        className="row"
                        style={{
                          "-webkit-align-items": "center",
                          "-webkit-box-align": "center",
                          "-ms-flex-align": "center",
                          "align-items": "center",
                          "margin-right": "0px !important",
                        }}
                      >
                        <div className="col col-8">
                          <div
                            className="tier-card text-center v-card v-sheet theme--light"
                            style={{
                              "background-color": "rgb(255, 255, 255)",
                              "border-color": "rgb(255, 255, 255)",
                            }}
                          >
                            <div className="v-card__text font-weight-bold pa-2">
                              Tier 2 (1.5%)
                            </div>
                          </div>
                        </div>
                        <div className="col" style={{ padding: "unset" }}>
                          <div className="v-card v-sheet theme--light">
                            <div className="v-card__text tier-card text-center pa-2">
                              0
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-timeline-item__divider">
                      <div className="v-timeline-item__dot">
                        <div
                          className="v-timeline-item__inner-dot"
                          style={{
                            "background-color": "rgb(255, 255, 255)",
                            "border-color": "rgb(255, 255, 255)",
                          }}
                        >
                          <img
                            src="/assets/icon/tier-icon-black.svg"
                            style={{ width: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                    <div className="v-timeline-item__body">
                      <div
                        className="row"
                        style={{
                          "-webkit-align-items": "center",
                          "-webkit-box-align": "center",
                          "-ms-flex-align": "center",
                          "align-items": "center",
                          "margin-right": "0px !important",
                        }}
                      >
                        <div className="col col-8">
                          <div
                            className="tier-card text-center v-card v-sheet theme--light"
                            style={{
                              "background-color": "rgb(255, 255, 255)",
                              "border-color": "rgb(255, 255, 255)",
                            }}
                          >
                            <div className="v-card__text font-weight-bold pa-2">
                              Tier 3 (1%)
                            </div>
                          </div>
                        </div>
                        <div className="col" style={{ padding: "unset" }}>
                          <div className="v-card v-sheet theme--light">
                            <div className="v-card__text tier-card text-center pa-2">
                              0
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-timeline-item__divider">
                      <div className="v-timeline-item__dot">
                        <div
                          className="v-timeline-item__inner-dot"
                          style={{
                            "background-color": "rgb(255, 255, 255)",
                            "border-color": "rgb(255, 255, 255)",
                          }}
                        >
                          <img
                            src="/assets/icon/tier-icon-black.svg"
                            style={{ width: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Refer;
